import { Navigate, useLocation } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import { czyTrasaTylkoDlaZalogowanych, zapamietajPowrot } from '@/lib/powrotPoLogowaniu';

/**
 * Catch-all dla WYLOGOWANEGO: trasa, która istnieje tylko z sesją (`/profile`, `/owner/…`),
 * prowadzi na `/login` i wraca po zalogowaniu (src/lib/powrotPoLogowaniu.ts); każda inna
 * to prawdziwe 404.
 */
export default function TrasaBezSesji() {
  const { pathname, search } = useLocation();
  if (!czyTrasaTylkoDlaZalogowanych(pathname)) return <NotFound />;
  zapamietajPowrot(pathname + search);
  return <Navigate to="/login" replace />;
}
